(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('pcard-color-preview')) {
  class PcardColorPreview extends HTMLElement {
    connectedCallback() {
      this.card = this.closest('.product-card');
      this.mainImage = this.card?.querySelector('.product-card__image--main img');
      this.productLink = this.card?.querySelector('.product-card__link');
      this.productTitle = this.card?.querySelector('.product-card__title');
      this.productPrice = this.card?.querySelector('.pcard-price-wrap');
      if (!this.mainImage || !this.productLink || !this.productTitle || !this.productPrice || this.onClick) return;
      this.links = [...this.querySelectorAll('a[data-pcard-preview]')].filter(link => link.querySelector('template')?.content.querySelector('img'));
      if (!this.original) {
        this.original = Object.fromEntries(['src', 'srcset', 'width', 'height', 'alt'].map(name => [name, this.mainImage.getAttribute(name)]));
        this.originalTitle = this.productTitle.innerHTML;
        this.originalPrice = this.productPrice.innerHTML;
        this.originalHref = this.productLink.getAttribute('href');
        this.originalLinkLabel = this.productLink.getAttribute('aria-label');
        this.originalLinkContent = this.productLink.innerHTML;
        this.currentLink = this.links.find(link => link.classList.contains('is-current'));
      }
      this.links.forEach(link => {
        link.setAttribute('role', 'button');
        link.setAttribute('aria-pressed', String(link.classList.contains('is-current')));
      });
      this.onClick = event => {
        if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        const link = event.target.closest('a[data-pcard-preview]');
        if (!link || !this.links.includes(link)) return;
        event.preventDefault();
        this.preview(link);
      };
      this.onKeydown = event => {
        if (event.key !== ' ' || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        const link = event.target.closest('a[data-pcard-preview]');
        if (!link || !this.links.includes(link)) return;
        event.preventDefault();
        this.preview(link);
      };
      this.onPointerover = event => {
        if (!['mouse', 'pen'].includes(event.pointerType) || event.buttons !== 0) return;
        const link = event.target.closest('a[data-pcard-preview]');
        if (!link || !this.links.includes(link) || (event.relatedTarget instanceof Node && link.contains(event.relatedTarget))) return;
        this.preview(link);
      };
      this.onFocusin = event => {
        const link = event.target.closest('a[data-pcard-preview]');
        if (link && this.links.includes(link)) this.preview(link);
      };
      this.addEventListener('pointerover', this.onPointerover);
      this.addEventListener('focusin', this.onFocusin);
      this.addEventListener('click', this.onClick);
      this.addEventListener('keydown', this.onKeydown);
    }

    disconnectedCallback() {
      if (!this.onClick) return;
      this.removeEventListener('pointerover', this.onPointerover);
      this.removeEventListener('focusin', this.onFocusin);
      this.removeEventListener('click', this.onClick);
      this.removeEventListener('keydown', this.onKeydown);
      this.onClick = null;
    }

    preview(link) {
      const content = link.querySelector('template')?.content;
      const image = content?.querySelector('img');
      const title = content?.querySelector('[data-preview-title]');
      const price = content?.querySelector('[data-preview-price]');
      if (!image || !title || !price) return;
      const isOriginal = link === this.currentLink;
      for (const name of ['srcset', 'src', 'width', 'height', 'alt']) {
        const value = isOriginal ? this.original[name] : image.getAttribute(name);
        if (value === null) this.mainImage.removeAttribute(name);
        else this.mainImage.setAttribute(name, value);
      }
      this.card.classList.toggle('pcard-color-preview-active', !isOriginal);
      this.productTitle.innerHTML = isOriginal ? this.originalTitle : title.innerHTML;
      this.productPrice.innerHTML = isOriginal ? this.originalPrice : price.innerHTML;
      this.productLink.setAttribute('href', isOriginal ? this.originalHref : link.getAttribute('href'));
      if (isOriginal) {
        this.productLink.innerHTML = this.originalLinkContent;
        if (this.originalLinkLabel === null) this.productLink.removeAttribute('aria-label');
        else this.productLink.setAttribute('aria-label', this.originalLinkLabel);
      } else {
        this.productLink.setAttribute('aria-label', link.getAttribute('aria-label'));
        const label = this.productLink.querySelector('.visually-hidden');
        if (label) label.textContent = link.getAttribute('aria-label');
      }
      this.links.forEach(option => {
        option.classList.toggle('is-current', option === link);
        option.setAttribute('aria-pressed', String(option === link));
      });
    }
  }
  customElements.define('pcard-color-preview', PcardColorPreview);
}
  } catch(e) { console.error(e); }
})();

})();
